// extracted by mini-css-extract-plugin
export default {"wrapper":"Vv-z","addressLine":"Wv-z","fullName":"Xv-z"};